import React, { PureComponent } from 'react'

export class VerbasESocial extends PureComponent {
  render() {
    return (
      <div>VerbasESocial</div>
    )
  }
}

export default VerbasESocial